import CreatePayoutAccountForm from '@/components/payout-account/CreatePayoutAccountForm';
import { useModal } from '@/hooks/shared/use-modal';

export interface CreatePayoutAccountModalProps {
  groupId: string;
}

export default function CreatePayoutAccountModal({ groupId }: CreatePayoutAccountModalProps) {
  const { close } = useModal();
  return (
    <div className="text-sm">
      <div className="text-lg font-semibold text-gray-800 dark:text-gray-100 py-2 mb-4">
        Lägg till utbetalningskonto
      </div>
      <CreatePayoutAccountForm onSuccess={close} />
    </div>
  );
}
